import React from "react";
import FieldMask from "src/components/common/FormComponents/FieldMask";
import { PhoneFieldsProps } from "src/components/Feedback/components/types";

const FieldPhone: React.FC<PhoneFieldsProps> = ({ control, errors }) => {
  return (
    <FieldMask
      control={control}
      error={errors.phone?.message}
      placeholder="+7 999 999-99-99"
    />
  );
};

export default FieldPhone;
